export default __webpack_public_path__ + "static/media/icon_garnet.2acbe277.png";